import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DEFAULT_REQUEST_PARAMS } from '../types';
import { AppApiService } from './app-api.service';

export interface BackendDataApiResponse<T> {
  data: T;
}

export interface BackendItemsApiResponse<T> {
  items: T;
}

export function convertApiDataResponseToItem<T>(backendResponse: Observable<BackendDataApiResponse<T>>): Observable<T> {
  return backendResponse.pipe(map(response => response.data));
}

export function convertApiItemsResponseToItems<T>(
  backendResponse: Observable<BackendItemsApiResponse<T>>,
): Observable<T> {
  return backendResponse.pipe(map(response => response.items));
}

export interface ServerTimeResponse {
  success: boolean;
  timestamp: number;
  timezone: string;
  offset: number;
}

@Injectable({
  providedIn: 'root',
})
export class OverbookingApiService {
  protected baseEndpoint = environment.overbooking.host;

  constructor(protected api: AppApiService) {}

  getServerTime(): Observable<ServerTimeResponse> {
    return this.api.get<ServerTimeResponse>(`${this.baseEndpoint}/api/config/server-time`, {
      ...DEFAULT_REQUEST_PARAMS,
    });
  }
}
